import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { StarIcon, MapPinIcon } from 'lucide-react';
export function QuickTestimonialsSection() {
  const testimonials = [{
    quote: 'Desde que tengo el pack nunca más dudé frente a un alumno.',
    name: 'Mariana G.',
    role: 'Profesora de Ed. Física',
    city: 'Buenos Aires',
    initials: 'MG'
  }, {
    quote: 'Uso las fichas antes de cada clase. Me cambió la forma de trabajar.',
    name: 'Lucas R.',
    role: 'Entrenador Personal',
    city: 'Córdoba',
    initials: 'LR'
  }, {
    quote: 'Finalmente tengo el respaldo técnico que me faltaba.',
    name: 'Florencia M.',
    role: 'Profesora de Ed. Física',
    city: 'Rosario',
    initials: 'FM'
  }];
  return <section className="py-10 bg-background-dark" data-id="element-266">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-267">
        <div className="grid md:grid-cols-3 gap-6" data-id="element-268">
          {testimonials.map((testimonial, index) => <FadeIn key={index} delay={0.1 * index} direction="up" data-id="element-269">
              <div className="bg-card-dark border border-primary/30 rounded-2xl p-6 h-full flex flex-col" data-id="element-270">
                <div className="flex gap-1 mb-6" data-id="element-271">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-272" />)}
                </div>

                <div className="flex items-center gap-4 mb-6" data-id="element-273">
                  <div className="w-12 h-12 rounded-full bg-primary flex items-center justify-center text-black font-bold text-lg shrink-0" data-id="element-274">
                    {testimonial.initials}
                  </div>
                  <div data-id="element-275">
                    <h4 className="font-bold text-white text-lg" data-id="element-276">
                      {testimonial.name}
                    </h4>
                    <div className="flex items-center gap-1 text-xs text-gray-400 mt-1" data-id="element-277">
                      <MapPinIcon className="w-3 h-3" data-id="element-278" />
                      <span data-id="element-279">
                        {testimonial.role} — {testimonial.city}
                      </span>
                    </div>
                  </div>
                </div>

                <p className="text-white italic text-lg leading-relaxed flex-1" data-id="element-280">
                  "{testimonial.quote}"
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}